import { FormEvent, useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { AuthLayout, Fehlermeldung } from './AuthLayout';
import { sicheresZiel } from '../../utils/sicheresZiel';

export default function LoginPage() {
  const { status, anmelden } = useAuth();
  const navigate = useNavigate();
  const ort = useLocation();
  const weiter = sicheresZiel(new URLSearchParams(ort.search).get('weiter'));
  const gesperrt = new URLSearchParams(ort.search).get('gesperrt') === '1';

  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [fehler, setFehler] = useState<unknown>(null);
  const [laeuft, setLaeuft] = useState(false);

  if (status === 'angemeldet') return <Navigate to={weiter} replace />;
  if (status === 'mfa_ausstehend') {
    return <Navigate to={`/mfa?weiter=${encodeURIComponent(weiter)}`} replace />;
  }

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaeuft(true);
    try {
      await anmelden(email, passwort);
      // Ob es weitergeht oder die Bestaetigung folgt, entscheidet der
      // Zustand oben -- hier wird nur der Fall ohne MFA behandelt.
      navigate(weiter, { replace: true });
    } catch (err) {
      setFehler(err);
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <AuthLayout
      titel="Anmelden"
      fusszeile={
        <>
          Noch kein Konto?{' '}
          <Link to="/registrieren" className="font-medium text-primary-600 hover:underline">
            Firma registrieren
          </Link>
        </>
      }
    >
      {gesperrt && (
        <p className="mb-4 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-800">
          Der Zugang dieser Firma ist gesperrt. Bitte wenden Sie sich an den Betreiber.
        </p>
      )}
      <Fehlermeldung fehler={fehler} />

      <form onSubmit={absenden} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            E-Mail
          </label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
          />
        </div>

        <div>
          <label htmlFor="passwort" className="block text-sm font-medium text-gray-700">
            Passwort
          </label>
          <input
            id="passwort"
            type="password"
            autoComplete="current-password"
            required
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
            className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
          />
        </div>

        <button
          type="submit"
          disabled={laeuft}
          className="flex w-full items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-60"
        >
          {laeuft && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Anmelden
        </button>

        <div className="text-center">
          <Link to="/passwort-vergessen" className="text-sm text-gray-600 hover:underline">
            Passwort vergessen?
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}
